import { FormDataConsumer, ReferenceInput, SelectInput } from "react-admin";

import React from "react";
import { get } from "lodash";

const DocSubcategorySelectWrapper = ({ choices, ...props }) =>
  choices.length > 0 && (
    <SelectInput {...props} choices={choices} optionText="description" />
  );

const DocSubcategoryInput = (props) => (
  <FormDataConsumer {...props}>
    {({ formData }) => {
      if (get(formData, "category_id", null) === null) {
        return null;
      }

      return (
        <ReferenceInput
          {...props}
          reference="doc-subcategories"
          sort={{ field: "description", order: "ASC" }}
          filter={{
            category_id: get(formData, "category_id"),
          }}
        >
          <DocSubcategorySelectWrapper />
        </ReferenceInput>
      );
    }}
  </FormDataConsumer>
);
export default DocSubcategoryInput;
